import { FieldValueModel } from 'shared/domain/fieldValue/fieldValueModel';
import { FieldValueEntity } from '../entity';

export function fieldValueEntityToModel(
  entity: FieldValueEntity
): FieldValueModel {
  const { _id, label, processes, valueTranslations, createdByClientId } =
    entity;

  return {
    _id,
    label,
    processes,
    valueTranslations,
    createdByClientId,
  };
}
